import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [salon, setSalon] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data.user);
    setSalon(data.salon);
    return data;
  };

  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) { setLoading(false); return; }
    refresh().catch(() => localStorage.removeItem("token")).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    setSalon(data.salon);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("token", data.token);
    setUser(data.user);
    setSalon(data.salon);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setSalon(null);
  };

  return (
    <AuthContext.Provider value={{ user, salon, loading, login, signup, logout, refresh, setSalon }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
